import gql from 'graphql-tag';

export default gql`
  query validatePromoCode($input: String!) {
    validatePromoCode(input: $input)
  }
`;
